import script from "./forgot-first.vue?vue&type=script&setup=true&lang=js"
export * from "./forgot-first.vue?vue&type=script&setup=true&lang=js"

import "./forgot-first.vue?vue&type=style&index=0&id=0f7f670c&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f7f670c"]])

export default __exports__